export default "__VITE_ASSET__cDzN_Il4__"